var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAkarIconsXFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63 6.54312L13.05 1.25H12.0025L8.16375 5.84562L5.09875 1.25H1.5625L6.19875 8.2L1.5625 13.75H2.61L6.66375 8.89687L9.90125 13.75H13.4375L8.63 6.54312ZM7.195 8.26063L6.725 7.56875L2.9875 2.0625H4.59688L7.61312 6.50625L8.0825 7.19813L12.0031 12.9744H10.3944L7.195 8.26063Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsXFill);
export default __webpack_public_path__ + "static/media/akar-icons_x-fill.5d04eadc645f6d7686b2b2c5b3ee5f3d.svg";
export { ForwardRef as ReactComponent };